<div class="hero-card" *ngIf="quizReady">
    <mat-card class="mat-card-in-progress-card">
        <mat-card-title>{{ 'inProgressQuiz.text1' | translate}}</mat-card-title>
        <div class="mb-8 in-progress-icon-container">
            <img src="./assets/imgs/inProgressQuizIcon.jpg" class="in-progress-icons"/>
        </div>
        <mat-card-content>
            <ul class="in-progress-container-items-list">
                <li>{{ 'inProgressQuiz.text2' | translate: { value: inProgressQuiz.storybookName } }}</li>
                <li>{{ 'inProgressQuiz.text3' | translate: { value: inProgressQuiz.stoppedOnQuestionNumber } }}</li>
                <li>{{ 'inProgressQuiz.text4' | translate: { value: inProgressQuiz.quizScore } }}</li>
                <li><button (click)="goToQuiz()" class="btn btn-primary">{{ 'inProgressQuiz.text5' | translate}}</button></li>
            </ul>
          </mat-card-content>


    </mat-card>
</div>
